module.exports = __webpack_public_path__ + "images/category_lp/car/store_images/4@2x_916aed6e39642eaf6534f99d0b1f4061.png";